import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const _cache = new Map(); // key: lang → { data, time }
const CACHE_TTL = 60000; // 60 seconds cache TTL

/** Admin-managed dotted-key translation overrides. */
export function useTranslationOverrides(lang) {
  const cached = _cache.get(lang);
  const isFresh = cached && (Date.now() - cached.time) < CACHE_TTL;
  const [overrides, setOverrides] = useState(isFresh ? cached.data : {});

  useEffect(() => {
    const existing = _cache.get(lang);
    if (existing && (Date.now() - existing.time) < CACHE_TTL) {
      setOverrides(existing.data);
      return;
    }
    let cancelled = false;
    axios.get(`${API}/translations`, { params: { lang } })
      .then((r) => {
        if (cancelled) return;
        const data = r.data || {};
        _cache.set(lang, { data, time: Date.now() });
        setOverrides(data);
      })
      .catch(() => { 
        if (!cancelled) { 
          _cache.set(lang, { data: {}, time: Date.now() }); 
          setOverrides({}); 
        } 
      });
    return () => { cancelled = true; };
  }, [lang]);

  return overrides;
}
